// extracted by mini-css-extract-plugin
export default {"welComeBox":"WelCome_welComeBox__f6Yn7"};